import { useState } from 'react';
import axios from 'axios';
import { DtoDataResLogin } from '../../Dto/DtosHome/DtosHomeResponse/DtoHomeResponseLogin';
import { Post } from '../../HTTP/Post';
import { REACT_APP_API_ENDPOINT_LOGIN_CLUB_ELITE, REACT_APP_IV, REACT_APP_KEY } from '../../../Domain/Settings/SettingsVariables';
import * as CryptoJS from "crypto-js";

//Feature: ApiLoginClubElite
//Autor: kevin.lopez
//Description: Función que se encarga de consumir el api de login de club elite.
function ApiLoginClubElite(requestDtoLoginClubElite) {
    const { AxiosPost } = Post();
    const key = CryptoJS.enc.Utf8.parse(REACT_APP_KEY);
    const iv = CryptoJS.enc.Utf8.parse(REACT_APP_IV);
    // let requestDtoRegisterJSON = requestDtoLogin;
    // requestDtoRegisterJSON.usuario =CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(requestDtoRegisterJSON.Identification), key,
    // {
    // keySize: 256 / 8,
    // iv: iv,
    // mode: CryptoJS.mode.CBC,
    // padding: CryptoJS.pad.Pkcs7
    // }).toString();
    const response = AxiosPost(`${REACT_APP_API_ENDPOINT_LOGIN_CLUB_ELITE}`, requestDtoLoginClubElite)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('Error:', error);
        });

    return response;
}

export default ApiLoginClubElite;